import {
	ApplyConsolidationPreviewMutation,
	CreateConsolidationPreviewMutation,
	SetConsolidationLotPinsMutation,
	UndoConsolidationApplicationMutation
} from "~/gql/mutations/produce/consolidationPreview.generated";
import {
	ConsolidationApplicationLotsQuery,
	ConsolidationApplicationQuery,
	ConsolidationApplicationsQuery,
	ConsolidationPreviewLotsQuery,
	StoredConsolidationPreviewQuery
} from "~/gql/queries/produce/consolidationPreview.generated";

const consolidationPreviewEndpoints = {
	ApplyConsolidationPreview: {
		invalidatesTags: (res: ApplyConsolidationPreviewMutation | undefined) =>
			res?.applyConsolidationPreview.success ? ["ConsolidationApplications" as const] : [],
		transformResponse: (res: ApplyConsolidationPreviewMutation) => res
	},
	ConsolidationApplication: {
		transformResponse: (res: ConsolidationApplicationQuery) => res
	},
	ConsolidationApplicationLots: {
		providesTags: ["ConsolidationApplications"] as AddTagTypes,
		transformResponse: (res: ConsolidationApplicationLotsQuery) => res
	},
	ConsolidationApplications: {
		providesTags: ["ConsolidationApplications"] as AddTagTypes,
		transformResponse: (res: ConsolidationApplicationsQuery) => res
	},
	ConsolidationPreviewLots: {
		providesTags: ["ConsolidationPreview"] as AddTagTypes,
		transformResponse: (res: ConsolidationPreviewLotsQuery) => res
	},
	CreateConsolidationPreview: {
		invalidatesTags: (res: CreateConsolidationPreviewMutation | undefined) =>
			res?.createConsolidationPreview.success ? ["ConsolidationPreview" as const] : [],
		transformResponse: (res: CreateConsolidationPreviewMutation) => res
	},
	SetConsolidationLotPins: {
		transformResponse: (res: SetConsolidationLotPinsMutation) => res
	},
	StoredConsolidationPreview: {
		providesTags: ["ConsolidationPreview"] as AddTagTypes,
		transformResponse: (res: StoredConsolidationPreviewQuery) => res
	},
	UndoConsolidationApplication: {
		invalidatesTags: (res: UndoConsolidationApplicationMutation | undefined) =>
			res?.undoConsolidationApplication.success ? ["ConsolidationApplications" as const] : [],
		transformResponse: (res: UndoConsolidationApplicationMutation) => res
	}
};

export default consolidationPreviewEndpoints;
